// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__LVy+h","preloader_global":"Preloader_preloader_global__MmUIM","preloader_inner":"Preloader_preloader_inner__SsS13"};